module.exports = __webpack_public_path__ + "img/nav_online_pay.bde769c7.png";